import { Box, constants, TextLink } from '@redbubble/design-system';
import React from 'react';
export var TopicNavItem = function (_a) {
    var label = _a.label, Icon = _a.Icon, _b = _a.active, active = _b === void 0 ? false : _b, href = _a.href, onClick = _a.onClick;
    return (React.createElement(TextLink, { href: href, onClick: onClick, "aria-current": active ? 'true' : undefined },
        React.createElement(Box, { display: "flex", flexDirection: "column", textAlign: constants.CENTER, alignItems: "center", flex: "0 0 auto", paddingY: "xxs", paddingX: "xs", paddingTop: "xs", className: [
                'rb-topic-nav__item',
                active ? 'rb-topic-nav__item--active' : undefined,
            ].join(' ') },
            Icon && React.createElement(Icon, null),
            React.createElement(Box, { paddingY: "xxxs" }, label))));
};
